import { useQuery } from '@tanstack/react-query'
import { fetchGoalsData } from '../data/goalsApi.js'

/**
 * Top-level hook for the full goals data array.
 * Every pillar eventually derives its slice from this single cached source —
 * so when one pillar mutates data, all other pillars see the update instantly.
 *
 * Cache key: ['goals']
 *
 * Same rationale as useMetaData: disable refetchOnWindowFocus, long stale
 * time, rely on Ably for real-time sync. KV's eventual consistency means
 * a refetch soon after a save can return stale data.
 */
export function useGoalsData() {
  return useQuery({
    queryKey: ['goals'],
    queryFn: fetchGoalsData,
    refetchOnWindowFocus: false,
    staleTime: 30_000,
  })
}
